import { styled } from '@mui/material/styles';
import { HEADER_HEIGHT } from '.';

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  minHeight: `${HEADER_HEIGHT}px`,
  justifyContent: 'flex-start'
}));
